import { AppSettingResponseModel } from '@uniquegood/realworld-admin-interface/dist';
import { Form, Input, InputNumber, Modal, ModalProps, Select } from 'antd';
import React from 'react';

interface DataType {
  type: string;
  key: string;
  os: string;
  value: string | number | boolean;
}

interface CreateSettingModalProps {
  modal: ModalProps;
  closeModal: () => unknown;
  currentData: AppSettingResponseModel;
  setSettingData: (data: AppSettingResponseModel) => void;
  os?: 'ios' | 'android' | 'common';
}

export default function CreateSettingModal({
  modal,
  closeModal,
  currentData,
  setSettingData,
  os
}: CreateSettingModalProps) {
  const [selected, setSelected] = React.useState('');

  const [form] = Form.useForm();

  const handleSubmit = () => {
    form.submit();
  };

  const handleClose = () => {
    form.setFieldsValue({
      type: null,
      key: null,
      value: null
    });
    setSelected('');
    closeModal();
  };

  /** OS(ios, android, common)에 세팅 데이터 추가 */
  const handleFinish = async (values: DataType) => {
    try {
      const { key, value } = values;
      const newData = {
        ...currentData,
        content: {
          ...currentData.content,
          [os as string]: {
            ...currentData.content[os as string],
            [key]: value
          }
        }
      }

      setSettingData(newData);
      handleClose();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Modal {...modal} onOk={handleSubmit} onCancel={handleClose}>
      <Form form={form} onFinish={handleFinish}>
        <Form.Item name="type">
          <Select
            onSelect={(value) => setSelected(value)}
            placeholder="타입을 선택해주세요."
            options={[
              { value: 'number', label: '숫자' },
              { value: 'string', label: '문자' },
              { value: 'boolean', label: '참 또는 거짓' }
            ]}
          />
        </Form.Item>
        <Form.Item name="key">
          <Input placeholder="속성 이름을 입력해주세요." />
        </Form.Item>
        {selected === 'boolean' && (
          <Form.Item name="value">
            <Select
              placeholder="선택해주세요."
              options={[
                { value: true, label: 'True' },
                { value: false, label: 'False' }
              ]}
            />
          </Form.Item>
        )}
        {selected === 'number' && (
          <Form.Item name="value">
            <InputNumber placeholder="값을 입력해주세요." style={{ width: '100%' }} />
          </Form.Item>
        )}
        {selected === 'string' && (
          <Form.Item name="value">
            <Input placeholder="값을 입력해주세요." />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
}
